import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertCircle } from 'lucide-react';

export function NoAccountPage() {
  const { signOut } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <div className="flex justify-center mb-4">
            <AlertCircle className="h-12 w-12 text-orange-500" />
          </div>
          <CardTitle className="text-2xl">No account assigned</CardTitle>
          <CardDescription>
            Your account hasn't been set up yet or has been removed. Please contact your
            administrator.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button onClick={() => signOut()} variant="outline">
            Sign out
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
